import React from 'react';

// Utility functions for CSV file generation and download
export const downloadCSV = (data, filename) => {
  if (!data || !data.length) {
    console.warn('No data provided for CSV download');
    return;
  }

  // Convert data to CSV format
  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','), // Header row
    ...data.map(row => 
      headers.map(header => {
        const value = row[header];
        // Escape commas and quotes in values
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        // Preserve 0 and false; only omit null/undefined
        return value !== null && value !== undefined ? value : '';
      }).join(',')
    )
  ].join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

// Component to replace CSVLink functionality
export const CSVDownloadButton = ({ data, filename, children, className, ...props }) => {
  const handleDownload = (e) => {
    e.preventDefault();
    downloadCSV(data, filename);
  };

  return (
    <a 
      href="#" 
      onClick={handleDownload} 
      className={className}
      {...props}
    >
      {children}
    </a>
  );
};

export default { downloadCSV, CSVDownloadButton };

